const therapies = [
  {
    key: 1,
    title: "Inspektion",
    text: "Die äußerliche Betrachtung (Inspektion) lässt z.B. Veränderungen der Afterhaut erkennen und liefert erste Hinweise auf innere Erkrankungen.",
    content: [
      "Die äußerliche Betrachtung (Inspektion) lässt z.B. Veränderungen der Afterhaut erkennen und liefert erste Hinweise auf innere Erkrankungen.",
    ],
  },
  {
    key: 2,
    title: "Palpation",
    text: "Die Austastung (Palpation) mit dem Finger ist äußerst wichtig und gibt dem Spezialisten mit seiner großen fachlichen Erfahrung bereits entscheidende Informationen zu Art und Ausmaß einer Erkrankung.",
    content: [
      "Die Austastung (Palpation) mit dem Finger ist äußerst wichtig und gibt dem Spezialisten mit seiner großen fachlichen Erfahrung bereits entscheidende Informationen zu Art und Ausmaß einer Erkrankung.",
    ],
  },
  {
    key: 3,
    title: "Proktoskopie",
    text: "Bei der Afterspiegelung (Proktoskopie) wird der Afterkanal (ca. 5 cm) mit einem kleinen Rohr inspiziert",
    content: [
      "Bei der Afterspiegelung (Proktoskopie) wird der Afterkanal (ca. 5 cm) mit einem kleinen Rohr inspiziert. Hierdurch kann der Enddarmspezialist z.B. erkennen, ob und in welchem Stadium Hämorrhoiden vorliegen.",
      "Mit Hilfe des Proktoskops werden die meisten Hämorrhoidenbehandlungen durchgeführt.",
    ],
  },
  {
    key: 4,
    title: "Rektoskopie",
    text: "Die Mastdarmspiegelung (Rektoskopie) gewährt Einsicht in den unteren Dickdarm. Mit ihr können Entzündungen, Polypen, aber auch bösartige Veränderungen erkannt werden",
    content: [
      "Die Mastdarmspiegelung (Rektoskopie) gewährt Einsicht in den unteren Dickdarm. Mit ihr können Entzündungen, Polypen, aber auch bösartige Veränderungen erkannt werden. Auch die Entnahme von Gewebeproben (Biopsie) ist bei allen Arten der Spiegelung möglich.",
      "Falls erforderlich, werden weitergehende Untersuchungen durchgeführt bzw. veranlasst. Hierzu gehören vor allem die komplette Darmspiegelung (Koloskopie) – auch als Vorsorgeuntersuchung - sowie der Ultraschall des Enddarms (Endosonographie).",
      "Nach der vollständigen Untersuchung wird Ihnen Ihr Enddarmspezialist die Gründe Ihrer Beschwerden erklären und die erforderlichen Behandlungen vorschlagen. Er wird Ihnen auch sagen, was Sie selbst tun können, um eine schnelle Heilung zu erreichen. Meist können Beschwerden ambulant, nur selten müssen sie stationär behandelt werden.",
    ],
  },
] as const;

export default therapies;
